import { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

export function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShow(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("cookie-consent", "all");
    setShow(false);
  };

  const rejectAll = () => {
    localStorage.setItem("cookie-consent", "rejected");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 pb-24 md:pb-6 pointer-events-none">
      <div className="max-w-4xl mx-auto bg-card/95 backdrop-blur-md border border-border rounded-xl shadow-2xl p-6 pointer-events-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex-1 space-y-2">
          <h3 className="text-lg font-semibold text-foreground">Wir schätzen Ihre Privatsphäre</h3>
          <p className="text-sm text-muted-foreground">
            Wir verwenden Cookies und ähnliche Technologien, um die ordnungsgemäße Funktion unserer Website zu gewährleisten, Inhalte und Anzeigen zu personalisieren und unseren Datenverkehr zu analysieren. Sie können wählen, ob Sie alle Cookies akzeptieren oder ablehnen möchten. Weitere Informationen finden Sie in unserer <Link to="/datenschutz" className="text-primary hover:underline">Datenschutzerklärung</Link>.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto shrink-0">
          <Button variant="outline" onClick={rejectAll} className="w-full sm:w-auto">
            Ablehnen
          </Button>
          <Button onClick={acceptAll} className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90">
            Alle akzeptieren
          </Button>
        </div>
      </div>
    </div>
  );
}
